/**
 * Downloads an image from any URL (including cross-origin Supabase URLs)
 * by fetching it as a blob first, which bypasses the browser's restriction
 * on the `download` attribute for cross-origin resources.
 *
 * @param {string} url - The image URL to download
 * @param {string} [filename='image.png'] - The filename to save as
 */
export const downloadImage = async (url, filename = 'image.png') => {
  if (!url) return;
  try {
    let objectUrl;
    let isObjectUrl = false;
    if (url.startsWith('data:')) {
      // data: URLs can be used directly as href — fetch() is blocked by CSP connect-src
      objectUrl = url;
    } else {
      const response = await fetch(url);
      const blob = await response.blob();
      objectUrl = window.URL.createObjectURL(blob);
      isObjectUrl = true;
    }
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (isObjectUrl) window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Error downloading image:', error);
  }
};
